export default __webpack_public_path__ + "static/media/oto_banner.97c22775.jpg";